import React from 'react';
import { Grid } from '@mui/material';
import RequestsPanel from './RequestsPanel';
import QualificationPanel from './QualificationPanel';

export default function RequestsStep() {
  return (
    <Grid container spacing={2} alignItems="flex-start">
      <Grid item xs={12} lg={8}>
        <RequestsPanel />
      </Grid>
      <Grid item xs={12} lg={4}>
        <QualificationPanel />
      </Grid>
    </Grid>
  );
}
